(function () {
  /* Side menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-menu-drawer]');
  function setMenu(open, returnFocus) {
    if (!toggle || !drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = drawer.querySelector('.menu-drawer__links a');
      if (first) setTimeout(function () { first.focus(); }, 50);
    } else if (returnFocus) {
      toggle.focus();
    }
  }
  if (toggle && drawer) {
    toggle.addEventListener('click', function () { setMenu(true); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-close]')) setMenu(false, true);
      else if (e.target.closest('.menu-drawer__links a')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setMenu(false, true);
    });
  }

  /* Feature band: play the uploaded video inside the card */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-band-video-play]');
    if (!btn) return;
    var frame = btn.closest('[data-band-video]');
    var video = frame && frame.querySelector('video');
    if (!video) return;
    video.controls = true;
    frame.classList.add('is-playing');
    var played = video.play();
    if (played && played.catch) played.catch(function () { frame.classList.remove('is-playing'); video.controls = false; });
  });
  document.addEventListener('ended', function (e) {
    var v = e.target;
    if (v && v.matches && v.matches('[data-band-video] video')) {
      v.controls = false;
      v.closest('[data-band-video]').classList.remove('is-playing');
    }
  }, true);

  var sel = document.querySelector('[data-variant-select]');
  if (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', sel.value);
      window.history.replaceState({}, '', u);
    });
  }
})();